import React, { useContext, useEffect, useMemo, useState } from "react";
import "./TermsAndConditions.sass";
//@ts-ignore
import { LocalizationContext } from "react-localize";
import { EXEC_MODE } from "cfg";
import { ReactAppMode } from "Interfaces/ReactAppModes";

const TermsAndConditions: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVCAPMode] = useState(() => {
    return [ReactAppMode.VCAP].includes(EXEC_MODE);
  });

  const { localize } = useContext(LocalizationContext);

  const terms_preview = isVCAPMode
        ? localize("static.content.vcap-terms-preview")
        : localize("static.content.terms-preview");

  const more_terms = isVCAPMode
        ? localize("static.content.vcap-more-terms")
        : localize("static.content.more-terms");

  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className="terms-container">
      <p className="terms-title">{localize("static.content.terms-conditions-label")}</p>
      
      <div className={`terms-content ${isExpanded ? "expanded" : "collapsed"}`}>
            
        <p className="terms-preview">
          <span
            dangerouslySetInnerHTML={{
              __html: terms_preview,
            }}
          ></span>
        </p>

        <button className="toggle-button" onClick={toggleExpanded}>
          {isExpanded ? <span>{localize("static.content.read-less-label")} <i className="fa fa-angle-up"></i></span> : <span>{localize("static.content.read-more-label")} <i className="fa fa-angle-down"></i></span>}
        </button>
        
        {isExpanded && (
          <p className="more-terms">
            <span
              dangerouslySetInnerHTML={{
                __html: more_terms,
              }}
            ></span>
          </p>
        )}
      </div>
    </div>
  );
};

TermsAndConditions.contextTypes = LocalizationContext;
export default TermsAndConditions;
